import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Audience`}</h1>
    <p>{`Use attributes to target an specific audience by using `}<a parentName="p" {...{
        "href": "http://jsonlogic.com/"
      }}>{`JsonLogic`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val userId = "676380e0-7793-44d6-9169-eb4208e17a86"
val featureId = "feature-1"

tesfyEngine.getVariationId(featureId, userId, mapOf("countryCode" to "ve")) // "0"
tesfyEngine.getVariationId(featureId, userId, mapOf("countryCode" to "us")) // null
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      